import EfFooterTc from '@elem/ui/ef-footer-tc';
import styles from './index.module.scss';

export default function TheComp() {
    const termsData = [
        {
            title: <strong>Footnotes：</strong>,
        },
        {
            title: '[1-8] All the test results displayed on the page are based on our internal testing, subject to different conditions, including temperature variations, humidity levels, and equipment calibration standards. Please note that these results are provided for informational purposes only and should not be considered as conclusive evidence for all scenarios',
        },
        {
            title: "* Data Source: Analysis based on EcoFlow's internal test data of 1kWh mainstream power stations on the market and their official data. DELTA 3 Plus's fast and safe charging performance is certified with a 5-star rating by SGS. Data is current as of August 28, 2024.",
        },
        {
            title: '* Download the EcoFlow PowerManager App to activate the NAS support function on your computer, then install the NUT Server software on your NAS system, connect your DELTA 3 Plus, and activate HID support. The formal launch version will come later in December.',
        },
        { title: '* EcoFlow DELTA 3 Series are compatible with DELTA Pro 3, DELTA 2 Max, DELTA 2.' },
    ];

    return (
        <div className={styles.TheComp}>
            <EfFooterTc list={termsData} />
        </div>
    );
}
